/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { StarIcon16Light } from './StarIcon16Light';
import { StarIcon16Regular } from './StarIcon16Regular';
import { StarIcon16Solid } from './StarIcon16Solid';
import { StarIcon20Light } from './StarIcon20Light';
import { StarIcon20Regular } from './StarIcon20Regular';
import { StarIcon20Solid } from './StarIcon20Solid';
import { StarIcon24Regular } from './StarIcon24Regular';
import { StarIcon24Solid } from './StarIcon24Solid';
import { StarIcon32Regular } from './StarIcon32Regular';
import { StarIcon64Regular } from './StarIcon64Regular';
var sizes = {
    16: {
        light: StarIcon16Light,
        regular: StarIcon16Regular,
        solid: StarIcon16Solid,
    },
    20: {
        light: StarIcon20Light,
        regular: StarIcon20Regular,
        solid: StarIcon20Solid,
    },
    24: {
        regular: StarIcon24Regular,
        solid: StarIcon24Solid,
    },
    32: {
        regular: StarIcon32Regular,
    },
    64: {
        regular: StarIcon64Regular,
    },
};
export var StarIcon = forwardRef('StarIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
